import { DataBean } from "../DataBean";

export class UBLDispatcherContingency extends DataBean {

    public async deleteUBLDispatcherContingency(idUBLDispatcherContingency: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteUBLDispatcherContingency_Number", [idUBLDispatcherContingency]);
    }

    public async getUBLDispatcherContingency(idUBLDispatcherContingency: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLDispatcherContingency_getUBLDispatcherContingency_Number", [idUBLDispatcherContingency]);
    }

    public async getUBLDispatcherContingencyCatalog(from: any, regex: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getUBLDispatcherContingencyCatalog_java.util.Date_String_Number_Number", [from, regex, page, recordsPerPage]);
    }

    public async updateUBLDispatcherContingency(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLDispatcherContingency_updateUBLDispatcherContingency_com.quickdataerp.bean.ubl.UBLDispatcherContingency", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.ubl.UBLDispatcherContingency"
            }
        ]);
    }

}
